/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applicants_Bulk_Waiting_ErrorInputs */

const en_applicants_bulk_waiting_error = /** @type {(inputs: Applicants_Bulk_Waiting_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to move applications to waiting list`)
};

const de_applicants_bulk_waiting_error = /** @type {(inputs: Applicants_Bulk_Waiting_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen konnten nicht auf die Warteliste gesetzt werden`)
};

/**
* | output |
* | --- |
* | "Failed to move applications to waiting list" |
*
* @param {Applicants_Bulk_Waiting_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applicants_bulk_waiting_error = /** @type {((inputs?: Applicants_Bulk_Waiting_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applicants_Bulk_Waiting_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applicants_bulk_waiting_error(inputs)
	return en_applicants_bulk_waiting_error(inputs)
});